var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21120_42382",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21120_42382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.82227 17.8411C8.49588 17.5148 8.33268 17.1224 8.33268 16.6641C8.33268 16.3724 8.40907 16.1016 8.56185 15.8516C8.71463 15.6016 8.91602 15.4002 9.16602 15.2474V13.3307H6.66602C6.20768 13.3307 5.81532 13.1675 5.48893 12.8411C5.16254 12.5148 4.99935 12.1224 4.99935 11.6641V9.7474C4.74935 9.6224 4.54796 9.4349 4.39518 9.1849C4.2424 8.9349 4.16602 8.65017 4.16602 8.33073C4.16602 7.8724 4.32921 7.48003 4.6556 7.15365C4.98199 6.82726 5.37435 6.66406 5.83268 6.66406C6.29102 6.66406 6.68338 6.82726 7.00977 7.15365C7.33615 7.48003 7.49935 7.8724 7.49935 8.33073C7.49935 8.65017 7.42296 8.92795 7.27018 9.16406C7.1174 9.40017 6.91602 9.59462 6.66602 9.7474V11.6641H9.16602V4.9974H7.49935L9.99935 1.66406L12.4993 4.9974H10.8327V11.6641H13.3327V9.9974H12.4993V6.66406H15.8327V9.9974H14.9993V11.6641C14.9993 12.1224 14.8362 12.5148 14.5098 12.8411C14.1834 13.1675 13.791 13.3307 13.3327 13.3307H10.8327V15.2474C11.0966 15.3863 11.3014 15.5807 11.4473 15.8307C11.5931 16.0807 11.666 16.3585 11.666 16.6641C11.666 17.1224 11.5028 17.5148 11.1764 17.8411C10.85 18.1675 10.4577 18.3307 9.99935 18.3307C9.54102 18.3307 9.14865 18.1675 8.82227 17.8411Z",
    fill: "#133F7D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsb);
export default __webpack_public_path__ + "static/media/usb.752a23f4cc3f93accc2f35b6377c92fb.svg";
export { ForwardRef as ReactComponent };